(function () {
  var root = document.querySelector('[data-wb2]');
  if (!root) return;
  var E = window.Endo || {};

  var ASSET_BASE = root.getAttribute('data-asset-base') || '';
  var SMALL_HANDLE = root.getAttribute('data-small-handle') || 'custom-wheel-set-small-emoto';
  var UB_HANDLE = root.getAttribute('data-ub-handle') || 'custom-wheel-set-ultra-bee';
  var VARG_HANDLE = root.getAttribute('data-varg-handle') || 'custom-wheel-set-stark-varg';
  var ADDON_HANDLE = root.getAttribute('data-addon-handle') || 'wheel-build-add-ons';
  var ROTORS_ON = root.getAttribute('data-enable-rotors') === 'true';

  function assetPath(rel) { return ASSET_BASE + 'wb--' + rel.replace(/\//g, '--') + '?v=5'; }

  var SWATCHES = {
    'Black': 'swatches/black.svg', 'Silver': 'swatches/silver.svg', 'Matte-Black': 'swatches/matte-black.svg',
    'Blue': 'swatches/blue.svg', 'Green': 'swatches/green.svg', 'Gold': 'swatches/gold.svg',
    'Magnesium': 'swatches/magnesium.svg', 'Orange': 'swatches/orange.svg', 'Purple': 'swatches/purple.svg',
    'Red': 'swatches/red.svg', 'Nardo-Grey': 'swatches/nardo-grey.svg',
    'School-Bus-Yellow': 'swatches/school-bus-yellow.svg', 'Flo-Yellow': 'swatches/flo-yellow.svg',
    'White': 'swatches/white.svg', 'Titanium': 'swatches/titanium.svg'
  };

  var RIM_COLORS = ['Black', 'Silver', 'Matte-Black', 'Blue', 'Green', 'Gold', 'Magnesium', 'Orange', 'Purple', 'Red'];
  var HUB_COLORS = ['Silver', 'Black', 'Red', 'Blue', 'Gold', 'Green', 'Orange', 'Purple', 'Magnesium'];
  var SPOKE_COLORS = ['Silver', 'Black', 'Blue', 'Green', 'Nardo-Grey', 'Orange', 'Red', 'White', 'School-Bus-Yellow', 'Flo-Yellow', 'Titanium'];
  var NIPPLE_COLORS = ['Silver', 'Black', 'Red', 'Blue', 'Orange', 'Green', 'Gold', 'Purple', 'Magnesium'];

  var CATALOG = {
    'Surron': [
      { id: 'LIGHT_BEE', label: 'LIGHT BEE', folder: 'Talaria_MX3', prefix: 'e-', cls: 'small' },
      { id: 'ULTRA_BEE', label: 'ULTRA BEE', folder: 'Stark_VARG', prefix: '', cls: 'ub' },
      { id: 'STORM_BEE', label: 'STORM BEE', folder: 'Stark_VARG', prefix: '', cls: 'ub' }
    ],
    'Talaria': [
      { id: 'STING_MX3', label: 'STING MX3', folder: 'Talaria_MX3', prefix: 'e-', cls: 'small' },
      { id: 'STING_R', label: 'STING R (MX4)', folder: 'Talaria_MX3', prefix: 'e-', cls: 'small' },
      { id: 'STING_MX5', label: 'STING MX5 PRO', folder: 'Talaria_MX3', prefix: 'e-', cls: 'small' },
      { id: 'XXX', label: 'TALARIA XXX', folder: 'Talaria_MX3', prefix: 'e-', cls: 'small' }
    ],
    'Stark': [{ id: 'VARG', label: 'STARK VARG', folder: 'Stark_VARG', prefix: '', cls: 'varg' }],
    'ERIDE': [
      { id: 'PRO_SS', label: 'ERIDE PRO-SS', folder: 'Talaria_MX3', prefix: 'e-', cls: 'small' },
      { id: 'SR_3', label: 'ERIDE PRO SR 3.0', folder: 'Talaria_MX3', prefix: 'e-', cls: 'small' }
    ],
    'Segway': [{ id: 'X260', label: 'SEGWAY X260 / X160', folder: 'Talaria_MX3', prefix: 'e-', cls: 'small' }],
    'Rawr': [{ id: 'MANTIS', label: 'RAWRR MANTIS', folder: 'Talaria_MX3', prefix: 'e-', cls: 'small' }],
    'Throne': [{ id: 'DEFENDER', label: 'THRONE DEFENDER', folder: 'Talaria_MX3', prefix: 'e-', cls: 'small' }],
    'Altis': [{ id: 'SIGMA', label: 'ALTIS SIGMA', folder: 'Talaria_MX3', prefix: 'e-', cls: 'small' }]
  };

  var STATE = {
    make: 'Surron', model: 'LIGHT_BEE', folder: 'Talaria_MX3', prefix: 'e-', cls: 'small', year: '2024',
    previewSide: 'FRONT', rimSizeFront: 'FRONT 16X1.65', rimSizeRear: 'REAR 16X1.85',
    rimType: 'Standard', tires: 'NO', rimColor: 'Black', hubColor: 'Silver', spokeColor: 'Silver', nippleColor: 'Silver',
    brakeRotor: 'no_rotor', rotorBolt: 'STANDARD',
    sprocketSize: ROTORS_ON ? '54' : 'no', sprocketBolts: 'STANDARD'
  };

  /* Fallback prices in cents; replaced by live variant prices once fetched */
  var FALLBACK = {
    smallSet: 38999, smallSetTires: 48999, ubSet: 54900, ubSetTires: 64900, vargSet: 85800,
    'Elite Rim Upgrade': 3000, 'Titanium Spokes': 4000,
    'Titanium Rotor Bolts': 1800, '203mm Fixed Rotor': 3500, '220mm Fixed Rotor': 4500,
    '220mm Floating Rotor': 6500, '240mm Floating Rotor + Bracket': 8500,
    'Rear Sprocket': 4500, 'Titanium Sprocket Bolts': 2000
  };
  var products = { small: null, ub: null, varg: null, addons: null };

  /* small e-moto class = Light Bee / Talaria / ERide / Segway / Rawrr / Throne / Altis platform */
  function classKey() { return STATE.cls || 'small'; }
  function setVariant() {
    var p = products[classKey()];
    if (!p || !p.variants || !p.variants.length) return null;
    if (classKey() === 'small' || classKey() === 'ub') {
      var want = STATE.tires !== 'NO' ? 'With Tires' : 'Without Tires';
      return p.variants.find(function (v) { return v.title === want || v.options[0] === want; }) || null;
    }
    return p.variants[0];
  }
  function setPriceCents() {
    var v = setVariant();
    if (v) return v.price;
    var k = classKey();
    if (k === 'varg') return FALLBACK.vargSet;
    if (k === 'ub') return STATE.tires !== 'NO' ? FALLBACK.ubSetTires : FALLBACK.ubSet;
    return STATE.tires !== 'NO' ? FALLBACK.smallSetTires : FALLBACK.smallSet;
  }
  function addonVariant(name) {
    if (!products.addons) return null;
    return products.addons.variants.find(function (v) { return v.title === name || v.options[0] === name; }) || null;
  }
  function addonPrice(name) {
    var v = addonVariant(name);
    return v ? v.price : (FALLBACK[name] || 0);
  }

  /* per-wheel add-ons carry qty 2 (front + rear) */
  function selectedAddons() {
    var list = [];
    if (STATE.rimType === 'Elite') list.push({ name: 'Elite Rim Upgrade', qty: 2 });
    if (STATE.spokeColor === 'Titanium') list.push({ name: 'Titanium Spokes', qty: 2 });
    if (ROTORS_ON) {
      if (STATE.rotorBolt === 'TITANIUM') list.push({ name: 'Titanium Rotor Bolts', qty: 1 });
      if (STATE.brakeRotor === '203mm_fixed') list.push({ name: '203mm Fixed Rotor', qty: 1 });
      if (STATE.brakeRotor === '220mm_fixed') list.push({ name: '220mm Fixed Rotor', qty: 1 });
      if (STATE.brakeRotor === '220mm_floating') list.push({ name: '220mm Floating Rotor', qty: 1 });
      if (STATE.brakeRotor === '240mm_floating') list.push({ name: '240mm Floating Rotor + Bracket', qty: 1 });
      if (STATE.brakeRotor === 'front_apex' || STATE.brakeRotor === 'rear_apex') list.push({ name: '220mm Floating Rotor', qty: 1 });
      if (STATE.sprocketSize !== 'no') list.push({ name: 'Rear Sprocket', qty: 1 });
      if (STATE.sprocketBolts === 'TITANIUM') list.push({ name: 'Titanium Sprocket Bolts', qty: 1 });
    }
    return list;
  }

  function computePriceCents() {
    var cents = setPriceCents();
    selectedAddons().forEach(function (a) { cents += addonPrice(a.name) * a.qty; });
    return cents;
  }
  function money(cents) {
    var d = cents / 100;
    return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2));
  }

  function buildCode() {
    var p = classKey() === 'varg' ? 'MX' : 'EMOTO';
    return [p, STATE.model.slice(0, 3), 'SET',
      STATE.rimColor.slice(0, 3).toUpperCase(), STATE.hubColor.slice(0, 3).toUpperCase(),
      STATE.spokeColor.slice(0, 3).toUpperCase(), STATE.nippleColor.slice(0, 3).toUpperCase()].join('-');
  }

  /* ---- DOM ---- */
  function $(id) { return document.getElementById(id); }
  var selMake = $('wb2_make'), selModel = $('wb2_model'), selYear = $('wb2_year'),
    selWheelType = $('wb2_wheel_type'), selRimSizeF = $('wb2_rim_size_front'), selRimSizeR = $('wb2_rim_size_rear'),
    selRimType = $('wb2_rim_type'), selTires = $('wb2_tires'), trTires = $('wb2_tr_tires'),
    selBrakeRotor = $('wb2_brake_rotor'), selRotorBolt = $('wb2_rotor_bolt'),
    selSprocketSize = $('wb2_sprocket_size'), selSprocketBolts = $('wb2_sprocket_bolts'),
    trSprocketSize = $('wb2_tr_sprocket_size'), trSprocketBolts = $('wb2_tr_sprocket_bolts'),
    labelRim = $('wb2_label_rim'), labelHub = $('wb2_label_hub'), labelSpoke = $('wb2_label_spoke'), labelNipple = $('wb2_label_nipple'),
    layerRim = $('wb2_layer_rim'), layerHubTop = $('wb2_layer_hub_top'),
    layerHubBottom = $('wb2_layer_hub_bottom'), layerHubBottomWrap = $('wb2_layer_hub_bottom_wrap'),
    layerSpokes = $('wb2_layer_spokes'), layerNipples = $('wb2_layer_nipples'),
    layerRotor = $('wb2_layer_rotor'), layerRotorWrap = $('wb2_layer_rotor_wrap'),
    layerSprocket = $('wb2_layer_sprocket'), layerSprocketWrap = $('wb2_layer_sprocket_wrap'),
    displayPrice = $('wb2_price'), btnAdd = $('wb2_add'), addNote = $('wb2_add_note');

  function setLayer(img, wrap, src) {
    if (!src) { if (wrap) wrap.style.display = 'none'; img.style.display = 'none'; return; }
    img.onerror = function () { this.style.display = 'none'; if (wrap) wrap.style.display = 'none'; };
    img.onload = function () { this.style.display = 'block'; if (wrap) wrap.style.display = 'block'; };
    img.src = src;
  }

  function updateModelOptions() {
    var list = CATALOG[STATE.make] || CATALOG.Surron;
    selModel.innerHTML = '';
    list.forEach(function (m) {
      var o = document.createElement('option');
      o.value = m.id; o.textContent = m.label;
      if (m.id === STATE.model) o.selected = true;
      selModel.appendChild(o);
    });
    if (!list.find(function (m) { return m.id === STATE.model; })) {
      STATE.model = list[0].id; STATE.folder = list[0].folder; STATE.prefix = list[0].prefix; STATE.cls = list[0].cls;
    }
  }

  function updateRotorOptions() {
    if (!ROTORS_ON || !selBrakeRotor) return;
    selBrakeRotor.innerHTML = '';
    var rotors = STATE.folder === 'Stark_VARG'
      ? [
        { id: 'no_rotor', label: 'NO ROTOR', file: '' },
        { id: 'front_apex', label: 'FRONT APEX ROTOR', file: 'rotors/front_apex_apex-rotor.png' },
        { id: 'rear_apex', label: 'REAR APEX ROTOR', file: 'rotors/rear_apex_rear-apex-rotor.png' }
      ]
      : [
        { id: 'no_rotor', label: 'NO ROTOR', file: '' },
        { id: '203mm_fixed', label: '203MM X 1.8 FIXED', file: 'rotors/203mm_fixed_203mm_x_1.8_Fixed-removebg-preview.png' },
        { id: '220mm_fixed', label: '220MM X 1.8 FIXED', file: 'rotors/220mm_fixed_220mm_x__1.8_Fixed-removebg-preview.png' },
        { id: '220mm_floating', label: '220MM X 2.3 FLOATING', file: 'rotors/220mm_floating_220mm_x_2.3_Floating-removebg-preview.png' },
        { id: '240mm_floating', label: '240MM X 2.3 FLOATING W/ BRACKET', file: 'rotors/240mm_floating_bracket_240mm_x_2.3_Floating_with_bracket_-removebg-preview.png' }
      ];
    rotors.forEach(function (r) {
      var o = document.createElement('option');
      o.value = r.id; o.textContent = r.label; o.dataset.file = r.file;
      if (r.id === STATE.brakeRotor) o.selected = true;
      selBrakeRotor.appendChild(o);
    });
    if (!rotors.find(function (r) { return r.id === STATE.brakeRotor; })) STATE.brakeRotor = rotors[0].id;
  }

  function createSwatches(containerId, colors, selected, onSelect) {
    var box = $(containerId);
    box.innerHTML = '';
    colors.forEach(function (c) {
      var el = document.createElement('button');
      el.type = 'button';
      el.className = 'wb2__swatch' + (c === selected ? ' is-active' : '');
      el.style.backgroundImage = 'url(' + assetPath(SWATCHES[c] || 'swatches/black.svg') + ')';
      el.title = c.replace(/-/g, ' ');
      el.setAttribute('aria-label', c.replace(/-/g, ' '));
      el.addEventListener('click', function () {
        box.querySelectorAll('.wb2__swatch').forEach(function (s) { s.classList.remove('is-active'); });
        el.classList.add('is-active');
        onSelect(c);
      });
      box.appendChild(el);
    });
  }

  function renderRimSwatches() {
    if (RIM_COLORS.indexOf(STATE.rimColor) === -1) STATE.rimColor = RIM_COLORS[0];
    createSwatches('wb2_rim_swatches', RIM_COLORS, STATE.rimColor, function (c) {
      STATE.rimColor = c; labelRim.textContent = c.replace(/-/g, ' '); render();
    });
    labelRim.textContent = STATE.rimColor.replace(/-/g, ' ');
  }

  function render() {
    var pos = STATE.previewSide;
    var isRearView = pos === 'REAR';
    var base = STATE.folder + '/';
    var pfx = STATE.prefix;

    if (trTires) trTires.style.display = classKey() === 'varg' ? 'none' : '';

    setLayer(layerRim, null, assetPath(base + 'rims/' + pfx + 'rim-' + STATE.rimColor + '-' + pos + '.png'));

    if (STATE.folder === 'Stark_VARG') {
      setLayer(layerHubTop, null, assetPath(base + 'hubs/' + pfx + 'hub-' + STATE.hubColor + '-' + pos + '.png'));
      layerHubBottomWrap.style.display = 'none';
    } else {
      layerHubBottomWrap.style.display = 'block';
      setLayer(layerHubTop, null, assetPath(base + 'hubs_top/' + pfx + 'hub-top-' + STATE.hubColor + '-' + pos + '.png'));
      setLayer(layerHubBottom, layerHubBottomWrap, assetPath(base + 'hubs_bottom/' + pfx + 'hub-bottom-' + STATE.hubColor + '-' + pos + '.png'));
    }

    setLayer(layerSpokes, null, assetPath(base + 'spokes/' + pfx + 'spokes-' + STATE.spokeColor + '-' + pos + '.png'));
    setLayer(layerNipples, null, assetPath(base + 'nipples/' + pfx + 'nipple-' + STATE.nippleColor + '-' + pos + '.png'));

    if (ROTORS_ON && selBrakeRotor) {
      var opt = selBrakeRotor.options[selBrakeRotor.selectedIndex];
      var rotorFile = opt ? opt.dataset.file : '';
      if (STATE.brakeRotor !== 'no_rotor' && rotorFile) {
        setLayer(layerRotor, layerRotorWrap, assetPath(base + rotorFile));
        layerRotorWrap.style.display = 'block';
      } else {
        layerRotorWrap.style.display = 'none';
      }
      if (isRearView && STATE.sprocketSize !== 'no') {
        var spFile = STATE.folder === 'Stark_VARG' ? 'sprockets/mx_sprocket_sprocket.png' : 'sprockets/sprocket_standard_rotor.png';
        setLayer(layerSprocket, layerSprocketWrap, assetPath(base + spFile));
        layerSprocketWrap.style.display = 'block';
      } else {
        layerSprocketWrap.style.display = 'none';
      }
      if (trSprocketSize) trSprocketSize.style.display = '';
      if (trSprocketBolts) trSprocketBolts.style.display = '';
    } else {
      layerRotorWrap.style.display = 'none';
      layerSprocketWrap.style.display = 'none';
    }

    displayPrice.textContent = money(computePriceCents());
  }

  function addToCart() {
    var sv = setVariant();
    if (!sv) {
      addNote.textContent = 'Wheel build product is not set up yet. Contact us and we will build it for you.';
      addNote.hidden = false;
      return;
    }
    var code = buildCode();
    var props = {
      'Bike': STATE.make + ' ' + (selModel.options[selModel.selectedIndex] || {}).textContent,
      'Year': STATE.year,
      'Wheels': 'FRONT + REAR SET',
      'Front Rim Size': STATE.rimSizeFront,
      'Rear Rim Size': STATE.rimSizeRear,
      'Rim': STATE.rimType + ' / ' + STATE.rimColor.replace(/-/g, ' '),
      'Hub': STATE.hubColor.replace(/-/g, ' '),
      'Spokes': STATE.spokeColor.replace(/-/g, ' '),
      'Nipples': STATE.nippleColor.replace(/-/g, ' '),
      'Build Code': code
    };
    if (classKey() === 'small' || classKey() === 'ub') {
      props['Tires'] = STATE.tires === 'NO' ? 'WITHOUT TIRES' : (STATE.tires === 'SUPERMOTO' ? 'SUPERMOTO TIRES' : 'DIRT TIRES');
    }
    if (ROTORS_ON && selBrakeRotor) {
      props['Rotor'] = (selBrakeRotor.options[selBrakeRotor.selectedIndex] || {}).textContent || 'NO ROTOR';
      props['Rotor Bolts'] = STATE.rotorBolt;
      props['Sprocket'] = STATE.sprocketSize === 'no' ? 'NO SPROCKET' : STATE.sprocketSize + ' TEETH';
      props['Sprocket Bolts'] = STATE.sprocketBolts;
    }
    var items = [{ id: sv.id, quantity: 1, properties: props }];
    selectedAddons().forEach(function (a) {
      var v = addonVariant(a.name);
      if (v) items.push({ id: v.id, quantity: a.qty, properties: { 'Build Code': code } });
    });

    btnAdd.disabled = true;
    btnAdd.classList.add('is-loading');
    addNote.hidden = true;
    var done = function () { btnAdd.disabled = false; btnAdd.classList.remove('is-loading'); };
    if (E.addItems) {
      E.addItems(items).then(done).catch(function () {
        done();
        addNote.textContent = 'Could not add to cart. Please try again.';
        addNote.hidden = false;
      });
    } else {
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function () { window.location.href = '/cart'; }).catch(done);
    }
  }

  function initListeners() {
    selMake.addEventListener('change', function (e) {
      STATE.make = e.target.value;
      updateModelOptions();
      var list = CATALOG[STATE.make];
      var m = list.find(function (x) { return x.id === STATE.model; }) || list[0];
      STATE.folder = m.folder; STATE.prefix = m.prefix; STATE.cls = m.cls;
      updateRotorOptions(); render();
    });
    selModel.addEventListener('change', function (e) {
      STATE.model = e.target.value;
      var m = (CATALOG[STATE.make] || []).find(function (x) { return x.id === STATE.model; });
      if (m) { STATE.folder = m.folder; STATE.prefix = m.prefix; STATE.cls = m.cls; }
      updateRotorOptions(); render();
    });
    selYear.addEventListener('change', function (e) { STATE.year = e.target.value; });
    selWheelType.addEventListener('change', function (e) { STATE.previewSide = e.target.value; render(); });
    selRimSizeF.addEventListener('change', function (e) { STATE.rimSizeFront = e.target.value; });
    selRimSizeR.addEventListener('change', function (e) { STATE.rimSizeRear = e.target.value; });
    selRimType.addEventListener('change', function (e) { STATE.rimType = e.target.value; render(); });
    if (selTires) selTires.addEventListener('change', function (e) { STATE.tires = e.target.value; render(); });
    if (selBrakeRotor) selBrakeRotor.addEventListener('change', function (e) { STATE.brakeRotor = e.target.value; render(); });
    if (selRotorBolt) selRotorBolt.addEventListener('change', function (e) { STATE.rotorBolt = e.target.value; render(); });
    if (selSprocketSize) selSprocketSize.addEventListener('change', function (e) { STATE.sprocketSize = e.target.value; render(); });
    if (selSprocketBolts) selSprocketBolts.addEventListener('change', function (e) { STATE.sprocketBolts = e.target.value; render(); });
    btnAdd.addEventListener('click', addToCart);
  }

  function fetchProducts() {
    var get = function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    };
    return Promise.all([get(SMALL_HANDLE), get(UB_HANDLE), get(VARG_HANDLE), get(ADDON_HANDLE)]).then(function (res) {
      products.small = res[0]; products.ub = res[1]; products.varg = res[2]; products.addons = res[3];
      render();
    });
  }

  updateModelOptions();
  updateRotorOptions();
  renderRimSwatches();
  createSwatches('wb2_hub_swatches', HUB_COLORS, STATE.hubColor, function (c) { STATE.hubColor = c; labelHub.textContent = c; render(); });
  createSwatches('wb2_spoke_swatches', SPOKE_COLORS, STATE.spokeColor, function (c) { STATE.spokeColor = c; labelSpoke.textContent = c; render(); });
  createSwatches('wb2_nipple_swatches', NIPPLE_COLORS, STATE.nippleColor, function (c) { STATE.nippleColor = c; labelNipple.textContent = c; render(); });
  var photoView = $('wb2_photo_view');
  var thumbs = document.querySelectorAll('[data-wb2-thumb]');
  thumbs.forEach(function (btn) {
    btn.addEventListener('click', function () {
      thumbs.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      if (btn.getAttribute('data-wb2-thumb') === 'live') {
        if (photoView) photoView.hidden = true;
      } else if (photoView) {
        photoView.src = btn.getAttribute('data-src');
        photoView.hidden = false;
      }
    });
  });

  initListeners();
  render();
  fetchProducts();
})();
